import { Sector } from 'shared/data/walletsKyc/v1';

import { companySectorMessages } from './StepForm.messages';

export const maxDocumentSize = 10 * 1024 * 1024;

const sectorToMessage = {
    [Sector.accountancy]: companySectorMessages.accountancy,
    [Sector.adult_entertainment]: companySectorMessages.adultEntertainment,
    [Sector.adult_products]: companySectorMessages.adultProducts,
    [Sector.advertising_or_public_relations_or_marketing]:
        companySectorMessages.advertisingOrPublicRelationsOrMarketing,
    [Sector.aerospace]: companySectorMessages.aerospace,
    [Sector.agricultural]: companySectorMessages.agricultural,
    [Sector.architecture]: companySectorMessages.architecture,
    [Sector.asset_or_wealth_management_or_wealth_tech]: companySectorMessages.assetOrWealthManagementOrWealthTech,
    [Sector.automobile_or_car_parts]: companySectorMessages.automobileOrCarParts,
    [Sector.banking]: companySectorMessages.banking,
    [Sector.bars_or_restaurants]: companySectorMessages.barsOrRestaurants,
    [Sector.bio_sciences_or_beauty_products]: companySectorMessages.bioSciencesOrBeautyProducts,
    [Sector.books_or_magazines_and_newspapers]: companySectorMessages.booksOrMagazinesAndNewspapers,
    [Sector.broker]: companySectorMessages.broker,
    [Sector.broker_dealer]: companySectorMessages.brokerDealer,
    [Sector.building_materials_and_equipment]: companySectorMessages.buildingMaterialsAndEquipment,
    [Sector.call_centres]: companySectorMessages.callCentres,
    [Sector.casinos_or_gambling]: companySectorMessages.casinosOrGambling,
    [Sector.chemical_and_related_manufacturing]: companySectorMessages.chemicalAndRelatedManufacturing,
    [Sector.clothing_or_textiles]: companySectorMessages.clothingOrTextiles,
    [Sector.computer_or_cyber_security]: companySectorMessages.computerOrCyberSecurity,
    [Sector.computer_software]: companySectorMessages.computerSoftware,
    [Sector.construction]: companySectorMessages.construction,
    [Sector.courier_or_express_or_parcel]: companySectorMessages.courierOrExpressOrParcel,
    [Sector.cryptoassets]: companySectorMessages.cryptoassets,
    [Sector.data_storage_or_processing]: companySectorMessages.dataStorageOrProcessing,
    [Sector.electronic_equipment_or_mobile_phones]: companySectorMessages.electronicEquipmentOrMobilePhones,
    [Sector.engineering]: companySectorMessages.engineering,
    [Sector.estate_or_letting_agency]: companySectorMessages.estateOrLettingAgency,
    [Sector.etailor_or_ecommerce]: companySectorMessages.etailorOrEcommerce,
    [Sector.fitness_equipment]: companySectorMessages.fitnessEquipment,
    [Sector.food_and_beverage]: companySectorMessages.foodAndBeverage,
    [Sector.forestry_and_forest_products]: companySectorMessages.forestryAndForestProducts,
    [Sector.freight_or_logistics]: companySectorMessages.freightOrLogistics,
    [Sector.fund]: companySectorMessages.fund,
    [Sector.furniture_and_flooring]: companySectorMessages.furnitureAndFlooring,
    [Sector.Gaming]: companySectorMessages.gaming,
    [Sector.hedge_fund_or_family_office]: companySectorMessages.hedgeFundOrFamilyOffice,
    [Sector.high_value_goods]: companySectorMessages.highValueGoods,
    [Sector.historical_or_cultural_artefacts]: companySectorMessages.historicalOrCulturalArtefacts,
    [Sector.hospitality_or_events_or_conferences]: companySectorMessages.hospitalityOrEventsOrConferences,
    [Sector.hospitals_and_care_facilities]: companySectorMessages.hospitalsAndCareFacilities,
    [Sector.hotels]: companySectorMessages.hotels,
    [Sector.insurance_or_insure_tech]: companySectorMessages.insuranceOrInsureTech,
    [Sector.interior_design]: companySectorMessages.interiorDesign,
    [Sector.it_managed_services]: companySectorMessages.itManagedServices,
    [Sector.legal]: companySectorMessages.legal,
    [Sector.loan_company]: companySectorMessages.loanCompany,
    [Sector.logging_timber_and_paper_mills]: companySectorMessages.loggingTimberAndPaperMills,
    [Sector.machinery_and_tools_or_industrial_equipment]: companySectorMessages.machineryAndToolsOrIndustrialEquipment,
    [Sector.mining_or_extractive_industries]: companySectorMessages.miningOrExtractiveIndustries,
    [Sector.money_services_business]: companySectorMessages.moneyServicesBusiness,
    [Sector.multi_level_marketing]: companySectorMessages.multiLevelMarketing,
    [Sector.music_production]: companySectorMessages.musicProduction,
    [Sector.nutritional_or_dietary_supplements]: companySectorMessages.nutritionalOrDietarySupplements,
    [Sector.oil_and_gas]: companySectorMessages.oilAndGas,
    [Sector.online_marketing_or_branding]: companySectorMessages.onlineMarketingOrBranding,
    [Sector.other_consultancy]: companySectorMessages.otherConsultancy,
    [Sector.packaging]: companySectorMessages.packaging,
    [Sector.pawn_brokers]: companySectorMessages.pawnBrokers,
    [Sector.payroll_company_or_pay_tech]: companySectorMessages.payrollCompanyOrPayTech,
    [Sector.pharmaceuticals_or_medical_devices]: companySectorMessages.pharmaceuticalsOrMedicalDevices,
    [Sector.political_group_or_lobbying]: companySectorMessages.politicalGroupOrLobbying,
    [Sector.precious_metals]: companySectorMessages.preciousMetals,
    [Sector.private_equity_or_investment_firm_or_venture_capital]:
        companySectorMessages.privateEquityOrInvestmentFirmOrVentureCapital,
    [Sector.property_development]: companySectorMessages.propertyDevelopment,
    [Sector.radio_or_tv_broadcaster]: companySectorMessages.radioOrTvBroadcaster,
    [Sector.real_estate_investment]: companySectorMessages.realEstateInvestment,
    [Sector.recruitment]: companySectorMessages.recruitment,
    [Sector.registered_charity]: companySectorMessages.registeredCharity,
    [Sector.regulated_online_marketplace_or_platform]: companySectorMessages.regulatedOnlineMarketplaceOrPlatform,
    [Sector.schools_and_universities]: companySectorMessages.schoolsAndUniversities,
    [Sector.security]: companySectorMessages.security,
    [Sector.speculative_trading]: companySectorMessages.speculativeTrading,
    [Sector.sporting_or_professional_club]: companySectorMessages.sportingOrProfessionalClub,
    [Sector.tax_advisers]: companySectorMessages.taxAdvisers,
    [Sector.taxi_or_private_transport]: companySectorMessages.taxiOrPrivateTransport,
    [Sector.telecoms]: companySectorMessages.telecoms,
    [Sector.tobacco_or_alcohol]: companySectorMessages.tobaccoOrAlcohol,
    [Sector.transportation]: companySectorMessages.transportation,
    [Sector.travel_agent_or_travel_website]: companySectorMessages.travelAgentOrTravelWebsite,
    [Sector.trust_and_company_formation_providers]: companySectorMessages.trustAndCompanyFormationProviders,
    [Sector.trust_company]: companySectorMessages.trustCompany,
    [Sector.unregistered_charity]: companySectorMessages.unregisteredCharity,
    [Sector.utilities]: companySectorMessages.utilities,
    [Sector.waste_management_or_recycling]: companySectorMessages.wasteManagementOrRecycling,
    [Sector.weapons_and_military_equipment]: companySectorMessages.weaponsAndMilitaryEquipment,
    [Sector.website_or_app_development]: companySectorMessages.websiteOrAppDevelopment,
};

export const companySectors = Object.keys(Sector).map((sector: Sector) => ({
    id: sector,
    name: sectorToMessage[sector],
}));
